import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest.js';

export const GetNetworkCombosRequest = () =>
	AxiosRequest({ method: 'GET', url: `${config.API_URL}Sites/GetNetworkCombos` });

export const GetAllSitesRequest = (filters) => {
	const params = {};
	if (filters.technologies?.length === 1) params.technology  = filters.technologies[0];
	if (filters.vendors?.length      === 1) params.vendor      = filters.vendors[0];
	if (filters.servers?.length      === 1) params.server      = filters.servers[0];
	if (filters.tacs?.length         === 1) params.tac         = filters.tacs[0];
	if (filters.startDate)                  params.windowStart = filters.startDate;
	if (filters.endDate)                    params.windowEnd   = filters.endDate;
	return AxiosRequest({ method: 'GET', url: `${config.API_URL}Sites/GetAllSites`, params });
};

export const GetActivityTitlesRequest = (filters) => {
	const params = {};
	if (filters.technologies?.length === 1) params.technology  = filters.technologies[0];
	if (filters.vendors?.length      === 1) params.vendor      = filters.vendors[0];
	if (filters.servers?.length      === 1) params.server      = filters.servers[0];
	if (filters.tacs?.length         === 1) params.tac         = filters.tacs[0];
	if (filters.startDate)                  params.windowStart = filters.startDate;
	if (filters.endDate)                    params.windowEnd   = filters.endDate;
	return AxiosRequest({ method: 'GET', url: `${config.API_URL}Sites/GetActivityTitles`, params });
};

export const GetSiteActivitiesRequest = ({ csr, technology, vendor, omcId, tac, activityStatus, startDate, endDate }) =>
	AxiosRequest({
		method: 'GET',
		url: `${config.API_URL}Sites/GetSiteActivities`,
		params: { csr, technology, vendor, omcId, tac, activityStatus, windowStart: startDate, windowEnd: endDate },
	});